<template>
  <ion-page>
    <ion-content :fullscreen="true" :scroll-events="true">
      <div id="container">
        <ion-card class="ion-margin-top" color="light">
          <ion-card-header>
            <ion-row>
              <ion-text
                class="negrita ion-align-self-center ion-text-capitalize"
              >
                {{
                  isAdmin && idProductor
                    ? "Establecimientos de " + nombreProductor
                    : "Mis Establecimientos"
                }}
              </ion-text>
              <ion-fab-button
                @click="createModal"
                size="small"
                class="ion-margin-left"
              >
                <ion-icon
                  color="light"
                  :md="icons.add"
                  :ios="icons.add"
                ></ion-icon>
              </ion-fab-button>
            </ion-row>
          </ion-card-header>
          <ion-card-content>
            <ion-list
              lines="full"
              v-for="est in establecimientos"
              :key="est._id"
            >
              <ion-item
                button="true"
                type="button"
                @click="editModal(est)"
                class="itemBorder"
              >
                <ion-row>
                  <!-- <div class="ion-text-start margen8pxArriba"> -->
                  <ion-col class="ion-text-left ion-text-capitalize">
                    <ion-text class="negrita" style="font-weight: bold">
                      {{ est.nombre }}
                    </ion-text>
                    <br />
                    <ion-text class="">
                      {{ est.localidad }}
                    </ion-text>
                  </ion-col>
                  <!-- </div> -->
                </ion-row>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>
        <ion-modal
          id="modal"
          :is-open="modalEdit"
          @didDismiss="modalEdit = false"
          :backdropDismiss="false"
        >
          <EstablecimientoForm
            :establecimiento="selectedEstablecimiento"
            :error="error"
            :persona="persona"
            @cancel="modalEdit = false"
            @submit="submitCreateOrEdit"
            @delete="deleteEstablecimiento"
            class="modal-wrapper"
          />
        </ion-modal>
        <div style="margin-bottom: 25%">
          <ion-button
            @click="volver"
            class="ion-margin-top ion-float-right ion-margin-bottom"
            style="margin-right:16px"
          >
            Volver
          </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonItem,
  IonText,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonContent,
  IonList,
  IonPage,
  IonIcon,
  IonRow,
  IonFabButton,
  IonButton,
  alertController,
  IonModal
} from "@ionic/vue";
import EstablecimientoForm from "../../components/EstablecimientoForm.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import http from "@/api/http";
import { Establecimientos, Persona } from "@/api";
import { addOutline, reloadOutline } from "ionicons/icons";

export default {
  components: {
    IonContent,
    IonText,
    IonItem,
    IonFabButton,
    IonIcon,
    IonList,
    IonButton,
    IonPage,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonRow,
    IonCol,
    IonModal,
    EstablecimientoForm
  },
  middleware: ["authenticated", "auth_cliente"],
  data: () => ({
    modalEdit: false,
    modalDelete: false,
    success: null,
    error: "",
    productor: {},
    selectedEstablecimiento: {},
    nombreProductor: "",
    icons: {
      add: addOutline,
      reload: reloadOutline
    },
    establecimientos: []
  }),

  computed: {
    ...mapState(["user"]),
    ...mapGetters(["isAdmin"]),
    idProductor() {
      return this.$route.params.idProductor;
    },
    persona() {
      if (this.isAdmin && this.idProductor) {
        if (this.productor && this.productor._id) {
          return this.productor;
        }
        return {};
      }
      return this.user;
    }
  },

  watch: {
    async idProductor() {
      await this.dataSync();
    }
  },

  async mounted() {
    await this.getMe();
    await this.dataSync();
  },

  methods: {
    ...mapActions(["getMe"]),
    async dataSync() {
      if (this.idProductor && this.isAdmin) {
        this.productor = await this.getProductor(this.idProductor);
        this.nombreProductor = this.productor.display_name;
      }
      await this.getEstablecimientos();
    },

    editModal(est) {
      this.error = "";
      this.selectedEstablecimiento = est;
      this.modalEdit = true;
    },

    createModal() {
      this.error = "";
      this.selectedEstablecimiento = {};
      this.modalEdit = true;
    },

    deleteModal(est) {
      this.selectedEstablecimiento = est;
      this.modalDelete = true;
    },

    async getEstablecimientos() {
      const pers = this.persona;
      if (!pers._id) {
        return;
      }
      const query = { persona: pers._id, deleted: false };

      const { data, error } = await Establecimientos.get({
        query: query,
        sort: { nombre: 1 }
      });
      if (error) {
        const alert = await alertController.create({
          header: "Error",
          message: "Error obteniendo Establecimientos.",
          buttons: [
            {
              text: "Aceptar"
            }
          ]
        });
        alert.present();
      }
      this.establecimientos = data;
    },

    goTo(item) {
      if (this.isAdmin && this.idProductor) {
        this.$router.push({
          name: "admin-productor-establecimiento",
          params: {
            idProductor: this.idProductor,
            tab: "Sl",
            idEstablecimiento: item._id
          }
        });
      } else {
        this.$router.push({
          name: "establecimiento",
          params: {
            tab: "Sl",
            idEstablecimiento: item._id
          }
        });
      }
    },

    async getProductor(idProductor) {
      const { data, error } = await Persona.getBy_id(idProductor);
      if (error) {
        const alert = await alertController.create({
          header: "Error",
          message: "Error obteniendo Productor.",
          buttons: [
            {
              text: "Aceptar"
            }
          ]
        });
        alert.present();
      }
      return data;
    },

    async updateRegionalesLotes(idEstablecimiento, idRegional) {
      const { data, error } = await http.post("/api/update-regionales-lotes", {
        params: {
          establecimiento: idEstablecimiento,
          regional: idRegional
        }
      });
      if (error) {
        const alert = await alertController.create({
          header: "Error",
          message: "Error actualizando regionales de lotes.",
          buttons: [
            {
              text: "Aceptar"
            }
          ]
        });
        return alert.present();
      }
      return data;
    },

    async submitCreateOrEdit({ establecimiento }) {
      this.error = "";
      const { error } = await Establecimientos.save(establecimiento);
      if (error) {
        this.error = error;
      } else {
        if (establecimiento && establecimiento._id) {
          await this.updateRegionalesLotes(
            establecimiento._id,
            establecimiento.regional
          );
        }
        this.success = true;
        const alert = await alertController.create({
          header: "Establecimientos",
          message: establecimiento._id
            ? "Establecimiento Actualizado"
            : "Establecimiento Creado",
          buttons: [
            {
              text: "Aceptar",
              handler: () => {
                this.dataSync();
              }
            }
          ]
        });
        this.modalEdit = false;
        alert.present();
      }
    },

    async deleteEstablecimiento() {
      const alert = await alertController.create({
        header: "Establecimiento",
        message: "¿Desea eliminar este establecimiento?",
        buttons: [
          {
            text: "Si",
            handler: async () => {
              const { error } = await Establecimientos.deleteReal(
                this.selectedEstablecimiento
              );
              if (!error) {
                const alert = await alertController.create({
                  header: "Establecimiento",
                  message: "Establecimiento Eliminado",
                  buttons: [
                    {
                      text: "Aceptar",
                      handler: () => {
                        this.modalEdit = false;
                        this.dataSync();
                      }
                    }
                  ]
                });
                alert.present();
              }
            }
          },
          {
            text: "No"
          }
        ]
      });
      alert.present();
    },

    volver() {
      if (this.isAdmin && this.idProductor) {
        this.$router.push({ name: "admin-lotes-productor" });
      } else {
        this.$router.push({ name: "persona-lotes" });
      }
    }
  }
};
</script>

<style scoped>
.modal-wrapper {
  background: transparent !important;
}

ion-modal {
  --ion-background-color: #ffffff85;
}

.negrita {
  color: black;
  font-size: 125%;
  margin-left: 0px;
}

.margen4px {
  margin-left: 4px;
}

.margen8px {
  margin-left: 8px;
}

.right {
  display: block;
  margin-left: auto;
  margin-right: 8px;
  float: right;
}

.width25 {
  width: 25%;
}

.margen9pxLados {
  margin-left: 9px;
  margin-right: 9px;
}

.leftMargin2vh {
  margin-left: 2vh;
}

.itemBorder {
  --border-color: var(--ion-color-secondary);
}

@media only screen and (min-width: 1024px) {
  #container {
    width: 50% !important;
    overflow: hidden !important;
    margin-left: 43px;
  }
}

ion-card {
  margin-top: 16px;
}
</style>
